import { GetPPGByPatientIdResponseDTO } from '@kulak91/everbeat-api-client';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationError } from '~/lib/exceptions';
import { AsyncThunkConfig } from '~/types/types';

type LoadPPGResultsRequestDTO = {
  patientId?: string;
};

const loadPPGResults = createAsyncThunk<GetPPGByPatientIdResponseDTO, LoadPPGResultsRequestDTO, AsyncThunkConfig>(
  'ppg/loadPPGResults',
  async ({ patientId }, { extra, getState }) => {
    const { user } = getState();
    const resolvedPatientId = patientId ?? user.data?.patientId;
    if (!resolvedPatientId) {
      throw new ApplicationError({ message: 'Patient ID is not available in user data' });
    }

    const { data, error } = await extra.services.ppg.getPPGDataByPatientId(resolvedPatientId);

    if (error) {
      throw new ApplicationError({ message: error.message });
    }

    return data;
  },
);

export { loadPPGResults };
